import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { GET_LOCATION_URL, ADD_LOCATION_URL, GET_STATE_URI, GET_LOCATION_TYPE } from '../../constant';
import { restrictZipInput } from '../../utils';

function EditLocationContent({ passengerId, onSaved }) {
  const [locations, setLocations] = useState([]);
  const [selectedLocId, setSelectedLocId] = useState('');
  const [form, setForm] = useState({});
  const [states, setStates] = useState([]);
  const [locTypes, setLocTypes] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        if (!passengerId) return;
        const [locRes, stateRes, typeRes] = await Promise.all([
          axios.get(`${GET_LOCATION_URL}/${passengerId}`),
          axios.get(GET_STATE_URI),
          axios.get(GET_LOCATION_TYPE),
        ]);
        setLocations(locRes.data || []);
        setStates(Array.isArray(stateRes.data) ? stateRes.data : []);
        setLocTypes(Array.isArray(typeRes.data?.data) ? typeRes.data.data : []);
      } catch (e) {
        setLocations([]);
      }
    };
    load();
  }, [passengerId]);

  const selected = useMemo(() => locations.find(l => String(l.loc_id) === String(selectedLocId)) || null, [locations, selectedLocId]);

  useEffect(() => {
    if (selected) {
      const resolveStateId = () => {
        if (selected.state?.state_id) return selected.state.state_id;
        if (selected.state?.state_name && Array.isArray(states) && states.length) {
          const match = states.find(s => String(s.state_name).toLowerCase() === String(selected.state.state_name).toLowerCase());
          return match?.state_id || '';
        }
        return '';
      };

      const resolveLocTypeCode = () => {
        if (selected.locationType?.location_type_code) return selected.locationType.location_type_code;
        if (selected.locationType?.location_type_name && Array.isArray(locTypes) && locTypes.length) {
          const match = locTypes.find(t => String(t.location_type_name).toLowerCase() === String(selected.locationType.location_type_name).toLowerCase());
          return match?.location_type_code || '';
        }
        return '';
      };

      setForm({
        loc_id: selected.loc_id,
        location_type: resolveLocTypeCode(),
        loc_name: selected.loc_name || '',
        loc_address: selected.loc_address || '',
        loc_city: selected.loc_city || '',
        loc_state: resolveStateId(),
        loc_zip: selected.loc_zip || '',
      });
    } else {
      setForm({});
    }
  }, [selected, states, locTypes]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!form.loc_id) return;
    setSaving(true);
    try {
        console.log('update location form',form);
      await axios.post(ADD_LOCATION_URL, form);
      setSaving(false);
      if (onSaved) onSaved(form.loc_id);
    } catch (e) {
      setSaving(false);
    }
  };

  return (
    <div style={{ minWidth: '520px' }}>
      <div className="mb-3">
        <label className='require-field'>Select Location</label>
        <select className="form-select" value={selectedLocId} onChange={(e) => setSelectedLocId(e.target.value)}>
          <option value="">Select</option>
          {locations.map((l) => (
            <option key={l.loc_id} value={l.loc_id}>
              {[l?.loc_name, l?.loc_address, l?.state?.state_name, l?.loc_city, l?.loc_zip].filter(Boolean).join(', ')}
            </option>
          ))}
        </select>
      </div>

      {selected && (
        <div className="form-items">
          <div className="form-floating mb-3">
            <select className="form-select require-field" name="location_type" value={form.location_type || ''} onChange={handleChange}>
              <option value="">Select Location Type</option>
              {locTypes.map(t => (
                <option key={t.location_type_code} value={t.location_type_code}>{t.location_type_name}</option>
              ))}
            </select>
            <label className='require-field'>Location Type</label>
          </div>
          <div className="form-floating mb-3">
            <input type="text" className="form-control" name='loc_name' value={form.loc_name || ''} onChange={handleChange} autoComplete="off" />
            <label className='require-field'>Address 1</label>
          </div>
          <div className="form-floating mb-3">
            <input type="text" className="form-control" name="loc_address" value={form.loc_address || ''} onChange={handleChange} autoComplete="off" />
            <label>Address 2</label>
          </div>
          <div className="form-floating mb-3">
            <input type="text" className="form-control" name="loc_city" value={form.loc_city || ''} onChange={handleChange} autoComplete="off" />
            <label className='require-field'>City</label>
          </div>
          <div className="form-floating mb-3">
            <select className="form-select require-field" name="loc_state" value={form.loc_state || ''} onChange={handleChange}>
              <option value="">Select State</option>
              {states.map(s => (
                <option key={s.state_id} value={s.state_id}>{s.state_name}</option>
              ))}
            </select>
          </div>
          <div className="form-floating mb-3">
            <input type="number" onInput={restrictZipInput} className="form-control" name="loc_zip" value={form.loc_zip || ''} onChange={handleChange} autoComplete="off" />
            <label className='require-field'>Zip</label>
          </div>

          <div className="d-flex justify-content-end">
            <button type="button" className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditLocationContent;


